import { Group } from '@mantine/core'
import React from 'react'

import fechar from '../../../icones/iconesVersaoEscura/fechar_janela.svg'
import ellipseVerde from '../../../icones/iconesVersaoVerde/ellipse.svg'
import { limparFiltr } from '../../../utils/alternanciaIcones'
import Icone from '../../Icone'
import Botao from '../Botao'

import * as S from './styles'

/**
 * @typedef {'filtro' | 'alerta' | 'default'} ModalType
 * @typedef {'center' | 'left'} PositionTitle
 * @typedef {'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'auto'} SizeType
 *
 * @typedef {Object} ModalProps
 * @property {React.ReactNode} titulo
 * @property {PositionTitle} [positionTitle='left']
 * @property {ModalType} [type='default']
 * @property {React.ReactNode} children
 * @property {SizeType} [size='auto']
 * @property {string} [width]
 * @property {string} [minHeight]
 * @property {boolean} [opened]
 * @property {() => void} close
 * @property {() => void} [onConfirm]
 * @property {() => void} [handleCleanFilters]
 * @property {boolean} [disableConfirm=false]
 * @property {boolean} [withCloseButton=true]
 * @property {boolean} [showActionsModal=true]
 * @property {string} [confirmLabel='Confirmar']
 * @property {string} [cancelLabel='Cancelar']
 * @property {() => void} [onBack] quando informado, o botão voltar chama onBack em vez de close
 * @property {boolean} [disableElipse=false]
 * @property {boolean} [hasIcon=false]
 * @property {{ name: string, color: string }} [icon]
 * @property {boolean} [useWhiteTheme=false]
 * @property {boolean} [closeOnClickOutside=true]
 * @property {boolean} [hasReportDownload=false]
 * @property {boolean} [disableReportDownload=false]
 * @property {() => void} [onReportDownload]
 */

/**
 * @param {ModalProps} props
 */
export default function Modal({
  titulo,
  positionTitle = 'left',
  type = 'default',
  children,
  size = 'auto',
  width,
  minHeight,
  opened,
  close,
  onConfirm,
  handleCleanFilters,
  disableConfirm = false,
  withCloseButton = true,
  showActionsModal = true,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onBack,
  disableElipse = false,
  hasIcon = false,
  icon,
  useWhiteTheme = false,
  closeOnClickOutside = true,
  hasReportDownload = false,
  disableReportDownload = false,
  onReportDownload,
  confirmButtonVariant = 'primary'
}) {
  const isFiltro = type === 'filtro'
  const isAlerta = type === 'alerta'
  const isDefault = type === 'default'
  const mostrarCloseButton = withCloseButton && !isFiltro && !isAlerta

  return (
    <S.ModalMantine
      useWhiteTheme={useWhiteTheme}
      type={type}
      width={width}
      minHeight={minHeight}
      size={size}
      closeOnClickOutside={closeOnClickOutside && !isAlerta}
      opened={opened}
      onClose={close}
      withCloseButton={mostrarCloseButton}
      closeButtonProps={{
        children: (
          <img
            className="botao-fechar-janela-icone"
            src={fechar}
            alt="fechar-janela"
          />
        )
      }}
      title={
        <S.TituloWrapper type={type}>
          {titulo && (
            <>
              {positionTitle === 'center' && (
                <S.TituloCenter>
                  {hasIcon && (
                    <S.BlankSlateWrapper>
                      <Icone
                        nome={icon.name}
                        color={icon.color}
                        width="32px"
                        height="32px"
                      />
                    </S.BlankSlateWrapper>
                  )}
                  <S.TituloModal useWhiteTheme={useWhiteTheme}>
                    {titulo}
                  </S.TituloModal>
                </S.TituloCenter>
              )}
              {positionTitle === 'left' && (
                <S.Titulo>
                  {!disableElipse && (
                    <S.Elipse src={ellipseVerde} alt="elipse" />
                  )}
                  <S.TituloModal useWhiteTheme={useWhiteTheme}>
                    {titulo}
                  </S.TituloModal>
                </S.Titulo>
              )}
            </>
          )}

          {isFiltro ? (
            <S.BotoesFiltroWrapper>
              <Botao
                label={
                  <S.LimparFiltroLabelWrapper onClick={handleCleanFilters}>
                    <span>LIMPAR FILTROS</span>
                    <img src={limparFiltr()} alt="fechar-janela" />
                  </S.LimparFiltroLabelWrapper>
                }
                variant="unstyled"
              />
              <Botao label="Filtrar" variant="primary" onClick={onConfirm} />
              <Botao label="Voltar" variant="outline" onClick={close} />
            </S.BotoesFiltroWrapper>
          ) : null}
        </S.TituloWrapper>
      }
      centered
    >
      <S.ModalContentWrapper>{children}</S.ModalContentWrapper>

      {showActionsModal && isDefault && (
        <S.ModalActionsWrapper hasReportDownload={hasReportDownload}>
          {hasReportDownload && (
            <Botao
              label="BAIXAR RELATÓRIO"
              variant="subtle"
              disabled={disableReportDownload}
              onClick={onReportDownload}
            />
          )}
          <Group position="center">
            <Botao
              label={cancelLabel}
              variant="outline"
              onClick={onBack ?? close}
            />
            <Botao
              label={confirmLabel}
              variant={confirmButtonVariant}
              disabled={disableConfirm}
              onClick={onConfirm}
            />
          </Group>

        </S.ModalActionsWrapper>
      )}
    </S.ModalMantine>
  )
}
